import { UserPermissions } from "./../../models/domains/pbm/user/user-permissions";
import { UserService } from "src/app/ui/services/user.service";
import { PageViews } from "./../../models/domains/features/custom-page-views";
import { Component, Input, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { Router } from "@angular/router";
import { RoutePath } from "../../models/domains/route-paths.model";
import { FeatureViewService } from "./../../services/feature-view.service";
import { environment } from "src/environments/environment";
import { AppContext } from "../../contexts/app-context";
import { MatMenuTrigger } from "@angular/material/menu";
import { MatSidenav } from "@angular/material/sidenav";
import { APP_VERSION } from "src/environments/version";
@Component({
  selector: "sidenav",
  templateUrl: "./sidenav.component.html",
  styleUrls: ["./sidenav.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class SidenavComponent implements OnInit {
  @Input() opened: boolean;
  @ViewChild("menuTrigger", { static: true }) menuTrigger: MatMenuTrigger;
  @ViewChild("sidenav", { static: true }) sidenav: MatSidenav;
  public showManagementGroupMenu = false;
  version = APP_VERSION;

  events: string[] = [];
  menuSidebar = [
    {
      link_name: "HOME",
      link: RoutePath.Home,
      icon: "home",
      sub_menu: null,
      hasPermission: true,
      isActive: PageViews.HomePageView,
      opened: false,
    },
    {
      link_name: "USUÁRIOS",
      link: RoutePath.SearchUser,
      icon: "account_circle",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchUser),
      isActive: PageViews.UserPageView,
      opened: false,
    },
    {
      link_name: "EMPRESAS",
      link: RoutePath.SearchCompany,
      icon: "work",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchCompany),
      isActive: PageViews.CompanyPageView,
      opened: false,
    },

    {
      link_name: "GESTÃO DE REGRAS",
      link: RoutePath.Campaigns,
      icon: "equalizer",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchCampaign),
      isActive: PageViews.CampaignPageView,
      opened: false,
    },
    {
      link_name: "BENEFÍCIOS",
      link: RoutePath.SearchBenefit,
      icon: "local_hospital",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchBenefit),
      isActive: PageViews.BenefitPageView,
      opened: false,
    },
    {
      link_name: "BENEFICIÁRIOS",
      link: RoutePath.SearchBeneficiary,
      icon: "assignment_ind",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchBeneficiary),
      isActive: PageViews.BeneficiaryPageView,
      opened: false,
    },
    {
      link_name: "HISTÓRICO DE VENDAS",
      link: RoutePath.SalesHistoryCompanies,
      icon: "shopping_cart",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchSalesHistory),
      isActive: PageViews.SalesHistoriesPageView,
      opened: false,
    },
    {
      link_name: "FECHAMENTO FINANCEIRO",
      link: RoutePath.CompanyFinancialReport,
      icon: "description",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.ViewCompanyFinancialReport),
      isActive: PageViews.FinancialReportPageView,
      opened: false,
    },
    {
      link_name: "EXTRATO BENEFICIÁRIOS",
      link: RoutePath.SearchFinancialStatement,
      icon: "account_balance",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchFinancialStatement),
      isActive: PageViews.FinancialStatementPageView,
      opened: false,
    },
    {
      link_name: "EXTRATO PDV",
      link: null,
      icon: "receipt",
      hasPermission: this.hasAccessTo(UserPermissions.SearchNetworkFinancialStatement),
      isActive: PageViews.NetworkFinancialStatementsPageView,
      opened: false,
      sub_menu: [
        {
          link_name: "VISÃO DE REDE",
          link: RoutePath.NetworkFinancialStatements,
          isActive: PageViews.NetworkFinancialStatementsPageView,
          hasPermission: this.hasAccessTo(UserPermissions.SearchNetworkFinancialStatement),
          opened: false,
        },
        {
          link_name: "VISÃO DE PAGAMENTO ",
          link: RoutePath.NetworkFinancialStatmentPayment,
          isActive: PageViews.NetworkFinancialStatementsPaymentPageView,
          hasPermission: this.hasAccessTo(UserPermissions.SearchNetworkFinancialStatement),
          opened: false,
        },
      ],
    },
    {
      link_name: "REDE CREDENCIADA",
      link: RoutePath.SearchNetworkTerm,
      icon: "group",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.SearchNetworkTerm),
      isActive: PageViews.NetworkTermPageView,
      opened: false,
    },
    {
      link_name: "GESTÃO",
      link: null,
      icon: "settings_applications",
      hasPermission: this.hasAccessToManagementButton(),
      opened: false,
      sub_menu: [
        {
          link_name: "GESTÃO LPM",
          link: RoutePath.SearchLpmCompanies,
          hasPermission: this.hasAccessTo(UserPermissions.ViewLpmManagement),
          opened: false,
        },
        {
          link_name: "GESTÃO TRANSACIONAL",
          link: RoutePath.TransactionalManagement,
          hasPermission: this.hasAccessTo(UserPermissions.TransactionalManagement),
          opened: false,
        },
        {
          link_name: "PAINEL DELIVERY",
          link: RoutePath.DeliveryPanel,
          hasPermission: this.hasAccessTo(UserPermissions.ViewDeliveryPanel),
          opened: false,
        },
        {
          link_name: "GESTÃO DE MÉDICOS",
          link: RoutePath.SearchPractitioner,
          hasPermission: this.hasAccessTo(UserPermissions.SearchPractitioner),
          opened: false,
        },
        {
          link_name: "GESTÃO DE CLUSTERS ",
          link: RoutePath.SearchClusterManagement,
          hasPermission: this.hasAccessTo(UserPermissions.ViewCluster),
          opened: false,
        },

        {
          link_name: "GESTÃO DE CATÁLOGO ",
          link: environment.productCatalog,
          hasPermission: this.hasAccessTo(UserPermissions.SearchProduct),
          externalOpening: true,
          opened: false,
        },
      ],
    },
    {
      link_name: "PORTAL DROGARIA",
      link: RoutePath.DrugstoreTests,
      icon: "local_pharmacy",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.PDVTest),
      isActive: PageViews.DrugstoreTests,
      opened: false,
    },
    {
      link_name: "RELATÓRIO GERAL",
      link: RoutePath.GeneralReport,
      icon: "file_download",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.ViewGeneralReport),
      isActive: PageViews.GeneralReport,
      opened: false,
    },
    {
      link_name: "AUDITORIA",
      link: RoutePath.AuditSale,
      icon: "verified",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.ViewAudit),
      isActive: PageViews.AuditSale,
      opened: false,
    },
    {
      link_name: "TRANSACTION LOG",
      link: RoutePath.TransactionLog,
      icon: "timeline",
      sub_menu: null,
      hasPermission: this.hasAccessTo(UserPermissions.ViewAudit),
      isActive: PageViews.TransactionLog,
      opened: false,
    },
  ];

  constructor(private context: AppContext, private router: Router, private featureViewService: FeatureViewService, private userService: UserService) { }

  ngOnInit() {
    this.btnColorValidation();
    this.fontColorValidation();
  }

  btnColorValidation() {
    return this.context.getCurrentTenant().tenantStyle.buttonBackgroundColor;
  }

  fontColorValidation() {
    return this.context.getCurrentTenant().tenantStyle.fontColor;
  }

  goTo(route: RoutePath): void {
    this.router.navigate([route]);
  }

  openSubMenu() {
    this.menuTrigger.openMenu();
  }

  isPageView(PermissionToPageView: string): boolean {
    const current = this.featureViewService.getActivePageView();
    return current === PermissionToPageView;
  }

  hasAccessTo(UserPermission: string): boolean {
    return this.userService.getLoggedUser().hasPermission(UserPermission);
  }

  hasAccessToManagementButton(): boolean {
    return (
      this.hasAccessTo(UserPermissions.ViewLpmManagement) ||
      this.hasAccessTo(UserPermissions.SearchProduct) ||
      this.hasAccessTo(UserPermissions.TransactionalManagement) ||
      this.hasAccessTo(UserPermissions.ViewDeliveryPanel) ||
      this.hasAccessTo(UserPermissions.SearchPractitioner) ||
      this.hasAccessTo(UserPermissions.ViewCluster)
    );
  }

  isAuditPageView(): boolean {
    return this.featureViewService.getActivePageView() === PageViews.AuditSale || this.featureViewService.getActivePageView() === PageViews.AuditSaleDetails;
  }
}
